import React, { Component } from 'react';
import $ from "jquery";
import TopMenu from '../commonFiles/TopMenu';
import Spinner from '../commonFiles/Spinner';
import Footer from '../commonFiles/Footer';
import Banner from './Banner';
import NewAndUpdatesInfo from './NewAndUpdatesInfo';
class OurServices extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){
  $("html, body").animate({ scrollTop: 0 });
  window.menu_selection('/new_updates');
}


  render() {
    return (
        <div className="container-xxl page_background p-0">
          <Spinner/>
          <TopMenu title="News And Updates"/>
          <NewAndUpdatesInfo/>
          <Footer />
        </div>
    );
  }
}

export default OurServices;
